import { useCallback } from 'react';
import { handleApiError, handleErrorWithFallback } from '../utils/errorHandling';

/**
 * Global error handler hook for React components
 * Provides consistent 401 error handling across all components
 */
export const useGlobalErrorHandler = () => {
  const handleError = useCallback((error: any, context?: string) => {
    handleApiError(error, context);
  }, []);

  const handleErrorWithMessage = useCallback((
    error: any, 
    context?: string, 
    fallbackMessage?: string
  ) => {
    return handleErrorWithFallback(error, context, fallbackMessage);
  }, []);

  return {
    handleError,
    handleErrorWithMessage,
  };
};
